/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 20H9C5.47353 20 2.55612 17.3923 2.07089 14C2.02417 13.6734 2 13.3395 2 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 6H9C5.13401 6 2 9.13401 2 13C2 13.3395 2.02417 13.6734 2.07089 14M22 6L18 2M22 6L18 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M22 6H9C5.13401 6 2 9.13401 2 13V13C2 16.866 5.13401 20 9 20H14M22 6L18 2M22 6L18 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M22 6H9C5.13401 6 2 9.13401 2 13V13C2 16.866 5.13401 20 9 20H14M22 6L18 2M22 6L18 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 6L18 2M22 6L18 10M22 6H15M14 20H9C5.13401 20 2 16.866 2 13V13C2 9.13401 5.13401 6 9 6H10.5H11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 6H9C5.13401 6 2 9.13401 2 13V13C2 16.866 5.13401 20 9 20H14M22 6L18 2M22 6L18 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M22 6H9C5.13401 6 2 9.13401 2 13V13C2 16.866 5.13401 20 9 20H14M22 6L18 2M22 6L18 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
